import { Box, Image, ImageProps, Theme, Typography } from "@outschool/backpack";
import { Space } from "@outschool/ui-legacy-component-library";
import React from "react";

type MarketingBannerProps = {
  title: string;
  cta: React.ReactNode;
  content: string | React.ReactNode;
  imagePath: string;
  subtext?: string;
  isFullWidth?: boolean;
  renderImage?: (props: ImageProps) => React.ReactElement;
};

const MarketingBanner = ({
  title,
  cta,
  content,
  imagePath,
  subtext = "",
  isFullWidth = false,
  renderImage,
}: MarketingBannerProps) => {
  return (
    <Box
      flex
      sx={(theme: Theme) => ({
        background: theme.gradients?.primarySecondary,
        boxShadow:
          "0px 1px 2px rgba(0, 0, 0, 0.08), 0px 4px 20px rgba(0, 0, 0, 0.08)",
        alignItems: "center",
        maxWidth: isFullWidth ? "100%" : "740px",
        margin: "auto",
        gap: "25px",
        justifyContent: "space-around",
        textWrap: "pretty",
        // mobile css
        flexDirection: "column",
        borderRadius: isFullWidth ? 0 : "16px",
        padding: "20px",
        // desktop css
        [theme.breakpoints.up("md")]: {
          flexDirection: "row",
          borderRadius: "16px",
          padding: isFullWidth ? "60px 160px" : "30px 40px 20px 25px",
        },
      })}
    >
      {renderImage ? (
        renderImage({
          src: imagePath,
          alt: title,
        })
      ) : (
        <Image
          src={imagePath}
          sx={{
            width: "140px",
            height: "auto",
          }}
        />
      )}
      <Box
        flex
        sx={(theme: Theme) => ({
          flexDirection: "column",
          textAlign: "center",
          [theme.breakpoints.up("md")]: {
            textAlign: "left",
          },
        })}
      >
        <Typography
          variant="h3"
          sx={(theme: Theme) => ({
            fontSize: `${theme.typography.pxToRem(28)} !important`,
          })}
        >
          {title}
        </Typography>
        <Space y="4px" />
        {content}
        <Space y="10px" />
        <Box>{cta}</Box>
        {subtext ? (
          <>
            <Space y="10px" />
            <Typography
              variant="inherit"
              sx={(theme: Theme) => ({
                fontSize: theme.typography.pxToRem(14),
              })}
            >
              {subtext}
            </Typography>
          </>
        ) : null}
      </Box>
    </Box>
  );
};

export default MarketingBanner;
